import { useCallback } from 'react';
import { Platform } from 'react-native';
import { useSafeNavigation, useSafeRouter } from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

export const useScanToPayNavigation = (closeModal: () => void) => {
  const isExpoRouterEnabled = useIsExpoRouterEnabled();
  const navigation = useSafeNavigation();
  const router = useSafeRouter();

  const goToSgRewards = useCallback(() => {
    closeModal();

    if (isExpoRouterEnabled) {
      router?.navigate('/loyalty');
      return;
    }

    navigation?.navigate('MainTabs', {
      screen: 'LoyaltyTab',
      params: {
        screen: 'LoyaltyHome',
      },
    });
  }, [closeModal, isExpoRouterEnabled, navigation, router]);

  const goToForgotToScan = useCallback(() => {
    closeModal();

    if (isExpoRouterEnabled) {
      router?.navigate('/forgot-to-scan');
      return;
    }

    navigation?.navigate('Modal', {
      screen: 'ForgotToScan',
    });
  }, [closeModal, isExpoRouterEnabled, navigation, router]);

  const goToSupport = useCallback(() => {
    closeModal();

    if (isExpoRouterEnabled) {
      router?.navigate('/chat');
      return;
    }

    navigation?.navigate('Modal', {
      screen: 'Chat',
    });
  }, [closeModal, isExpoRouterEnabled, navigation, router]);

  const goToPayments = useCallback(() => {
    closeModal();

    if (isExpoRouterEnabled) {
      router?.navigate({
        pathname: '/payments',
        params: { redirectTo: `https://${host}/scan-at-checkout` },
      });
      return;
    }

    navigation?.navigate('Modal', {
      screen: 'Payments',
      params: { redirectTo: `https://${host}/scan-at-checkout` },
    });
  }, [closeModal, isExpoRouterEnabled, navigation, router]);

  const goBack = useCallback(() => {
    closeModal();

    if (isExpoRouterEnabled) {
      router?.back();
      return;
    }

    navigation?.goBack();
  }, [closeModal, isExpoRouterEnabled, navigation, router]);

  return {
    goToSgRewards,
    goToForgotToScan,
    goToSupport,
    goToPayments,
    goBack,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const host = Platform.select({
  web: window.location.host,
  default: 'order.sweetgreen.com',
});
